<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_thicknesses') }}
      </h3>
      <hr />
    </div>
    <div class="columns is-multiline">
      <div v-for="key in thicknessKeys" :key="key" class="column is-4">
        <b-field
          :label="$translate(key) | capitalize"
          :type="{ 'is-danger': errors.has(key) }"
          :message="errors.first(key)"
        >
          <b-numberinput
            v-model="mod.thicknesses[key]"
            v-validate="'min_value:0|max_value:200'"
            :name="key"
            :min="0"
            :max="200"
            :use-html5-validation="false"
            :disabled="disabledbool"
          ></b-numberinput>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thicknesses',
  inject: ['$validator'],
  props: ['orderbool', 'mod', 'disabledbool'],
  data() {
    return {
      thicknessKeys: ['heel_height', 'ball_height', 'fings_height', 'sup_col_med', 'avvolgenza_mediale'],
    }
  },
  watch: {
    mod() {
      this.ensureStructure()
    },
  },
  created() {
    this.ensureStructure()
  },
  methods: {
    ensureStructure() {
      if (!this.mod) return
      if (!this.mod.thicknesses) {
        this.$set(this.mod, 'thicknesses', {})
      }
      this.thicknessKeys.forEach(key => {
        if (this.mod.thicknesses[key] == null) {
          this.$set(this.mod.thicknesses, key, 0)
        }
      })
    },
  },
}
</script>
